import { yupResolver } from '@hookform/resolvers/yup';
import { Button, ControlledInput, FileUpload, Typography } from '@p2p/components';
import { useForm } from 'react-hook-form';

import { MainContainer } from '../MainContainer';
import { PaymentId } from '../PaymentId';
import { ProblemsScreen } from './components';
import { commentInput, schema, titles } from './TransferIssues.constants';
import styles from './TransferIssues.module.scss';
import { FormValues, TransferIssuesProps } from './TransferIssues.types';

export const TransferIssues = ({
  id,
  comeback,
  onSubmit,
  isLoading,
  fileProps,
}: TransferIssuesProps) => {
  const {
    handleSubmit,
    control,
    setValue,
    setError,
    getValues,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      selectedIssue: null,
      comment: '',
      files: [],
    },
    resolver: yupResolver(schema),
  });
  const selectedIssue = watch('selectedIssue');

  if (selectedIssue === null) {
    return (
      <ProblemsScreen
        id={id}
        comeback={comeback}
        handleNext={(selectedIssue) => setValue('selectedIssue', selectedIssue)}
      />
    );
  }

  const onSubmitForm = (data: FormValues) => {
    onSubmit(data, { setValue, setError });
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <MainContainer marginTop="2xl" maxWidth="460px" className={styles.container}>
        <Typography variant="h1" color="heading">
          {titles[selectedIssue]}
        </Typography>

        <PaymentId id={id} />

        <Typography variant="text-m-regular">
          Пожалуйста, загрузите чек об оплате, на котором четко видны реквизиты получателя.
        </Typography>

        <FileUpload
          files={getValues('files')}
          setFiles={(files) => setValue('files', files)}
          error={errors.files?.message || ''}
          setError={(error) => setError('files', { message: error })}
          maxCountFiles={fileProps?.maxCountFiles || 3}
          allowedFormats={fileProps?.allowedFormats || ['jpeg', 'jpg', 'pdf', 'png']}
          maxFileSize={fileProps?.maxFileSize || 5}
          title={fileProps?.title}
          multiple
        />

        {commentInput[selectedIssue] && (
          <ControlledInput
            control={control}
            name="comment"
            label={commentInput[selectedIssue].label}
            placeholder={commentInput[selectedIssue].placeholder}
          />
        )}

        <div className={styles.actions}>
          <Button type="submit" disabled={isLoading} fullWidth>
            Отправить
          </Button>
          <Button onClick={comeback} variant="outlined" fullWidth>
            Вернуться к платежу
          </Button>
        </div>
      </MainContainer>
    </form>
  );
};
